import './Footer.css'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__divider">
          {'-'.repeat(300)}
        </div>
        <div className="footer__copyright">
          Tonbo IO © 2025-2026
        </div>
      </div>
    </footer>
  )
}
